let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6aGQ5")).then(() => parcelRequire('9pfti'));